import { render, staticRenderFns } from "./SalazarRomero.vue?vue&type=template&id=0ad58386&scoped=true&"
import script from "./SalazarRomero.vue?vue&type=script&lang=js&"
export * from "./SalazarRomero.vue?vue&type=script&lang=js&"
import style0 from "./SalazarRomero.vue?vue&type=style&index=0&id=0ad58386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad58386",
  null
  
)

export default component.exports